import { lazy } from 'react';

const SurveyBankModal = lazy(() =>
  import('modules/SurveyBankManagement/components/SurveyBankModal'),
);

export default {
  SURVEY_BANK_MODAL: SurveyBankModal,
};
